import "./app.scss";
import "bootstrap/dist/css/bootstrap.css";
import { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Import from react-router-dom
import Navbar from "./components/Header";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Certificates from "./pages/Certificates";
import Guidance from "./pages/Guidance";
import NotFound from "./pages/NotFound";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <Router>
      <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/certification" element={<Certificates />} />
        <Route path="/guidance" element={<Guidance />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
